import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { HttpClient } from '@angular/common/http';
import { map, Observable, tap } from 'rxjs';
import { AdhesionDataModel } from '../../../helpers/objects/dto/sales-portal/adhesion-data/adhesion-data-model';
import { AdhesionDataResponseModel } from '../../../helpers/objects/response/sales-portal/adhesion-data/adhesion-data-response-model';

@Injectable({
  providedIn: 'root'
})
export class DataAdhesionService {
  appConfig: EnvironmentModel = new EnvironmentModel();
  private readonly selectedApi: string = '';

  constructor(@Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel, private http: HttpClient) {
    this.appConfig = appConfigTemp;

    if (this.appConfig.platform === 'fhps') {
      this.selectedApi = this.appConfig.api + 'external/';
    } else {
      this.selectedApi = this.appConfig.api;
    }
  }

  get(id: number): Observable<AdhesionDataModel> {
    let url = this.selectedApi + 'subscription/' + this.appConfig.apiPartnershipId + '/proposals/' + id;
    return this.http.get<any>(url).pipe(
      // tap((response) => sessionStorage.setItem('public_token', response.body.token)),
      map((response) => response.body as AdhesionDataModel)
    );
  }

  set(body: AdhesionDataModel) {
    const url = this.selectedApi + 'subscription/' + this.appConfig.apiPartnershipId + '/proposals';
    return this.http.post<any>(url, body).pipe(
      tap((response) => {
        if (sessionStorage.getItem('public_token') != null && sessionStorage.getItem('public_token')?.length) {
          sessionStorage.setItem('public_token', response.body.token);
        }
      }),
      map((response) => response.body as AdhesionDataResponseModel)
    );
  }

  put(body: AdhesionDataModel) {
    const url = this.selectedApi + 'subscription/' + this.appConfig.apiPartnershipId + '/proposals/' + body.proposalId;
    return this.http.put<any>(url, body).pipe(map((response) => response.body as AdhesionDataResponseModel));
  }
}
